module.exports = __webpack_public_path__ + "img/1.d6fcf5e4.svg";